import { Component } from '@angular/core';

@Component({
    selector: 'login-failed',
    template: `<p>Login failed. Unauthorized. Please try again.</p>`,
    styleUrls: [],
    standalone: true
})
export class FailedComponent {}
